export default class SearchableObjectHelper {
	private DEFAULT_PAGE_SIZE = 50;
	amountOfItemsToShow: number = this.DEFAULT_PAGE_SIZE;

	searchableObj: Record<string, any> = {};

	constructor(searchableObject: Record<string, any>) {
		this.searchableObj = searchableObject;
	}

	/**
	 * Handles the search query. Filters the list based on the search text. Then sorts and limits the items to show.
	 * @param searchText - The search text to filter the items.
	 * @returns The filtered items.
	 */
	handleSearch(searchText: string = ''): Record<string, any> {
		const items: Record<string, any> = {};

		//get searched for items
		const searched = this.filterRecords(searchText);

		//get the keys of the searched for items
		const list = Object.keys(searched);

		// sort the list and get the items to show. Then add them to the items object
		list.sort((a, b) => a.toString().localeCompare(b.toString()))
			.slice(0, this.amountOfItemsToShow)
			.forEach(key => {
				items[key as string] = searched[key];
			});

		// ONLY SHOW THE AMOUNT OF ITEMS TO SHOW
		return items;
	}

	/**
	 * Resets the amount of items to show.
	 */
	resetPageSize() {
		this.amountOfItemsToShow = this.DEFAULT_PAGE_SIZE;
	}

	/**
	 * Increments the amount of items to show.
	 */
	incrementPageSize() {
		this.amountOfItemsToShow += this.DEFAULT_PAGE_SIZE;
	}

	flattenObject(obj: Record<string, any>) {
		const result: Record<string, any> = {};

		// Helper function to recursively flatten the object
		function flatten(currentObj: Record<string, any>, prefix = '') {
			// Handle primitive values (base case)
			if (typeof currentObj !== 'object' || currentObj === null) {
				// console.log('prefix', prefix);
				result[prefix] = currentObj;
				return;
			}

			// Handle arrays
			if (Array.isArray(currentObj)) {
				currentObj.forEach((item, index) => {
					const newPrefix = prefix ? `${prefix} ${index + 1}` : `${index + 1}`;
					flatten(item, newPrefix);
				});
				return;
			}

			// Handle objects
			for (const key in currentObj) {
				if (Object.prototype.hasOwnProperty.call(currentObj, key)) {
					const newPrefix = prefix ? `${prefix} ${key}` : key;

					if (typeof currentObj[key] === 'object' && currentObj[key] !== null) {
						flatten(currentObj[key], newPrefix);
					} else {
						// console.log('key', key);
						// console.log('currentObj[key]', currentObj[key]);
						result[newPrefix] = currentObj[key];
					}
				}
			}
		}

		flatten(obj);
		return result;
	}

	/**
	 * Filters the DBData object based on the search text.
	 * @param searchText - The search text to filter the DBData object.
	 * @returns The filtered DBData object.
	 */
	filterRecords(searchText: string = ''): Record<string, any> {
		const flattened = this.flattenObject(this.searchableObj);

		// must remove array property names and only keep the values. It should be labeled as WeOwe 1 cost, WeOwe 2 cost, etc.
		if (!searchText || searchText.length < 3) return flattened as Record<string, any>;

		const filtered: Record<string, any> = {};
		const searchTextLower = searchText.toLowerCase();

		for (const [key, value] of Object.entries(flattened)) {
			const keyMatch = String(key).toLowerCase().includes(searchTextLower);
			const valueMatch = value !== null && String(value).toLowerCase().includes(searchTextLower);
			if (keyMatch || valueMatch) {
				filtered[key] = value;
			}
		}

		return filtered;
	}
}
